"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { CardSlider, } from "./CardSlider";
import { CategoryFilter } from "./CategoryFilter";
// Update the FilterableCardSlider component to pass through the custom arrow props
export const FilterableCardSlider = ({ children, className = "", showIndicators = true, infiniteLoop = false, autoPlay = false, autoPlayInterval = 5000, pauseOnHover = true, 
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
transitionEffect = "slide", transitionDuration = 300, itemsPerView, cardWidth = 320, categoryProp = "category", prevArrow, nextArrow, renderArrow, }) => {
    const [activeCategory, setActiveCategory] = useState(null);
    // Process children to extract categories and filter by active category
    const { categories, filteredChildren, categoryCounts } = React.useMemo(() => {
        // 1) Flatten children
        const childrenArray = React.Children.toArray(children !== null && children !== void 0 ? children : []);
        const categorySet = new Set();
        const counts = {};
        // 2) Process & filter
        const filtered = childrenArray.filter((child) => {
            var _a;
            // skip anything that isn’t a React element
            if (!React.isValidElement(child))
                return false;
            // 3) Cast props to a safe indexable type
            const props = child.props;
            // 4) Extract & narrow the category
            const candidate = props[categoryProp];
            if (typeof candidate !== "string")
                return false;
            // now it’s safe to use as a string
            categorySet.add(candidate);
            counts[candidate] = ((_a = counts[candidate]) !== null && _a !== void 0 ? _a : 0) + 1;
            // if you have an activeCategory filter:
            return activeCategory === null || candidate === activeCategory;
        });
        return {
            categories: Array.from(categorySet),
            filteredChildren: filtered,
            categoryCounts: counts,
        };
    }, [children, categoryProp, activeCategory]);
    // const { categories, filteredChildren, categoryCounts } = React.useMemo(() => {
    //   const childrenArray = React.Children.toArray(children ?? []);
    //   const categorySet = new Set<string>();
    //   const counts: Record<string, number> = {};
    //   childrenArray.forEach((child) => {
    //     if (!React.isValidElement(child)) return;
    //     // safely grab the category (might be undefined)
    //     const category = child.props?.[categoryProp];
    //     // explicitly check that it's not null/undefined
    //     if (category !== undefined && category !== null) {
    //       categorySet.add(category);
    //       counts[category] = (counts[category] || 0) + 1;
    //     }
    //   });
    //   // Filter children by active category
    //   const filtered =
    //     activeCategory === null
    //       ? childrenArray
    //       : childrenArray.filter(
    //           (child) =>
    //             React.isValidElement(child) &&
    //             child.props &&
    //             child.props[categoryProp] === activeCategory,
    //         );
    //   return {
    //     categories: Array.from(categorySet),
    //     filteredChildren: filtered,
    //     categoryCounts: counts,
    //   };
    // }, [children, activeCategory, categoryProp]);
    // If no categories found, just render the regular slider
    if (categories.length === 0) {
        return (_jsx(CardSlider, { showIndicators: showIndicators, infiniteLoop: infiniteLoop, autoPlay: autoPlay, autoPlayInterval: autoPlayInterval, pauseOnHover: pauseOnHover, transitionEffect: transitionEffect, transitionDuration: transitionDuration, itemsPerView: itemsPerView, cardWidth: cardWidth, className: className, prevArrow: prevArrow, nextArrow: nextArrow, renderArrow: renderArrow, children: children }));
    }
    // Update the second CardSlider usage to pass through the custom arrow props
    return (_jsxs("div", { className: className, children: [_jsx(CategoryFilter, { categories: categories, activeCategory: activeCategory, onChange: setActiveCategory, categoryCounts: categoryCounts }), filteredChildren.length > 0 ? (_jsx(CardSlider, { showIndicators: showIndicators, infiniteLoop: infiniteLoop, autoPlay: autoPlay, autoPlayInterval: autoPlayInterval, pauseOnHover: pauseOnHover, transitionEffect: transitionEffect, transitionDuration: transitionDuration, itemsPerView: itemsPerView, cardWidth: cardWidth, prevArrow: prevArrow, nextArrow: nextArrow, renderArrow: renderArrow, children: filteredChildren })) : (_jsx("div", { className: "rounded-lg border border-gray-200 bg-gray-50 p-8 text-center", children: _jsx("p", { className: "text-gray-500", children: "No items found in this category." }) }))] }));
};
export default FilterableCardSlider;
